import React, { Dispatch } from "react";
import { RouteComponentProps, Redirect, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { appPaths, IAppState, PageTitleSetter, appPageTitles } from "../../Common";
import { ProtectedRoute } from "../../Auth";
import UserProfileContainer from "./Profile/UserProfileContainer";
import UserProfileFeatureRequestsContainer from "./Profile/UserProfileFeatureRequestsContainer";
import UserProfileBugReportsContainer from "./Profile/UserProfileBugReportsContainer";
import UserProfileResourceRequestsContainer from "./Profile/UserProfileResourceRequestsContainer";
import UserSettingsContainer from "./Settings/UserSettingsContainer";
import { setPath, setBreadcrumbs } from "../../Startup/Actions/StartupActions";
import { BreadcrumbData, breadcrumbService } from "../../Layout";
import { breadcrumbsMap } from "../Constants/breadcrumbsMap";
import { UserAssignedFeedbacksContainer } from "./AssignedFeedbacks/UserAssignedFeedbacksContainer";

type TParams = {
  username: string;
};

type StateProps = {
  path?: string;
};

type DispatchProps = {
  setPath: (path: string) => void;
  setBreadcrumbs: (breadcrumbs: Promise<BreadcrumbData[]>) => void;
};

const mapStateToProps = (state: IAppState): StateProps => ({
  path: state.app.path
});

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchProps => ({
  setPath: (path: string) => dispatch(setPath(path)),
  setBreadcrumbs: (breadcrumbs: Promise<BreadcrumbData[]>) => dispatch(setBreadcrumbs(breadcrumbs))
});

class UserRoutes extends React.Component<
  RouteComponentProps<TParams> & StateProps & DispatchProps
> {
  variableResolver = async (key: string, variables: Map<string, string>) => {
    return variables.get(key);
  };

  setBreadcrumbs = () => {
    if (this.props.path !== this.props.location.pathname) {
      // this.props.setPath(this.props.location.pathname);

      this.props.setBreadcrumbs(
        breadcrumbService.createBreadcrumbs(
          this.props.location.pathname,
          breadcrumbsMap,
          this.variableResolver
        )
      );
    }
  };

  render() {
    this.setBreadcrumbs();

    return (
      <>
        <PageTitleSetter title={appPageTitles.general} />
        <Switch>
          <ProtectedRoute exact path={appPaths.user.settings} component={UserSettingsContainer} />
          <ProtectedRoute exact path={appPaths.user.root} component={UserProfileContainer} />
          <ProtectedRoute
            exact
            path={appPaths.user.featureRequests}
            component={UserProfileFeatureRequestsContainer}
          />
          <ProtectedRoute
            exact
            path={appPaths.user.bugReports}
            component={UserProfileBugReportsContainer}
          />
          <ProtectedRoute
            exact
            path={appPaths.user.resourceRequests}
            component={UserProfileResourceRequestsContainer}
          />
          <ProtectedRoute
            exact
            path={appPaths.user.assigned}
            component={UserAssignedFeedbacksContainer}
          />
          <Redirect to={appPaths.notFound} />
        </Switch>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRoutes);
